import acceptances from './acceptances/store';
import appointment from './appointment/store';
import digitalRoom from './digital-room/store';
import dpg from './dpg/store';
import favorite from './favorite/store';
import gltf from './gltf/store';
import group from './group/store';
import inspections from './inspections/store';
import magazine from './magazine/store';
import magazines from './magazines/store';
import nav from './nav/store';
import quotation from './quotation/store';
import retrieval from './retrieval/store';
import room from './room/store';
import roomShow from './room-show/store';

export default {
    namespaced: true,
    modules: {
        acceptances,
        appointment,
        digitalRoom,
        dpg,
        favorite,
        gltf,
        group,
        inspections,
        magazine,
        magazines,
        nav,
        quotation,
        retrieval,
        room,
        roomShow,
    },
};
